import React from 'react';
import { reactLocalStorage } from 'reactjs-localstorage';

import Select from 'react-select';
import Table from 'react-bootstrap/Table';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import ModulAPI from '../../../api/ModulAPI';
import withRouter from '../../../util/WithRouter';
import Const from '../../../util/Constants';
import DefaultControllerConst from '../../../util/DefaultControllerConst';
import Util from '../../../util/Util';
import ApiUiController from '../../../controller/ApiUiController';
import FieldListRows from './FieldListRows';
import FieldListHeader from './FieldListHeader';

class FieldList extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      inApiCall: true, popup: false, field: {
        id: 0, label_name: '', field_type: '', combine: '',
        validate: '*', is_visible: 0, editable: 0, duplicate: 0, field_order: 0, model_no: 0
      }
    };

    this.path = props.match.path;
    this.path = this.path.substring(0, this.path.lastIndexOf('/'), '');
    this.modelNo = parseInt(props.match.params.modelId);
    let model = reactLocalStorage.getObject(Const.Model);
    const key = Object.keys(model).find(key => model[key].model_no === this.modelNo);
    this.model = model[key];
    this.fields = this.loadModelList();
    this.i = -1;
    this.fieldOptions = [
      { label: 'Text', value: Const.Text },
      { label: 'TextArea', value: Const.TextArea },
      { label: 'Single Select', value: Const.Select },
      { label: 'Multiple Select', value: Const.MultiSelect },
      { label: 'Date', value: Const.Date },
      { label: 'Date Time', value: Const.DateTime },
      { label: 'Decimal (10.50, 1000.00, etc)', value: Const.Decimal },
      { label: 'Number (1, 2, 3, 4, 5, etc)', value: Const.Number }
    ];

    this.validationOptions = [
      { label: 'Compulsory', value: Const.Mandatory },
      { label: 'Not Compulsory', value: Const.NonMandatory }
    ];

    const modelCat = model.field_option;
    model = model.field_key;
    this.List = Util.isAllow(model.permission, Const.PermView);
    this.Add = Util.isAllow(model.permission, Const.PermAdd);
    this.Update = Util.isAllow(model.permission, Const.PermUpdate);
    this.Delete = Util.isAllow(model.permission, Const.PermDelete);
    this.CatList = Util.isAllow(modelCat.permission, Const.PermView);
    this.user = reactLocalStorage.getObject(Const.LoggedInUser);

    this.showConditional = this.modelNo === 1 && this.user.package === Const.PackageEnterprise;

    this.options = this.getEditableFields(this.fields);
  }

  componentDidMount() { if (this.List) ModulAPI.get(this.modelNo, this.onReceived, this.onFail); }

  onFail = (res) => {
    const message = res.message ? JSON.stringify(res.message) : 'Something went wrong';
    Util.showError(message);
    this.setState({ ...this.state, inApiCall: false });
  };

  onReceived = module => {
    this.model = module;
    this.fields = this.loadModelList();
    this.setState({ inApiCall: false });
  };

  loadModelList = () => {
    let fields = Object.keys(this.model.fields).map(key => this.model.fields[key]);
    fields = fields.filter(field => field.status !== Const.Trash);
    return fields;
  };

  show = i => {
    this.i = i;
    let field;
    if (i !== -1) {
      field = { ...this.fields[i] };
    } else {
      field = {
        id: 0, model_no: this.modelNo, field_type: '', label_name: '',
        field_order: this.fields.length, visible: 1, editable: 1, validate: '',
        non_duplicate: 0, form_mandate: 0, api_mandate: 0, import_mandate: 0, combine: "",
        default_value: '', calculate: '', filter_visible: 1, filter_field_order: this.fields.length, status: 1
      };
    }
    this.setState({ ...this.state, popup: true, selected: '', field: field });
  };
  hide = () => this.setState({ ...this.state, popup: false });

  //onCheckChange = (key, val) => this.onChange(key, val ? Const.True : Const.False);
  onCheckChange = (key, val) => {
    const field = { ...this.state.field };
    if (key === 'visible' && !val) {
      field['non_duplicate'] = Const.False;
      field['form_mandate'] = Const.False;
      field['api_mandate'] = Const.False;
      field['import_mandate'] = Const.False;
    }
    field[key] = val ? Const.True : Const.False;
    this.setState({ ...this.state, field: field });
  };

  onFieldTypeChange = selected => {
    this.setState({ ...this.state, selected: selected });
    this.onChange('field_type', selected !== null ? selected.value : '');
  };
  onChange = (key, val) => {
    const field = { ...this.state.field }; field[key] = val;
    this.setState({ ...this.state, field: field });
  };

  submit = () => {
    this.setState({ ...this.state, popup: false });
    const title = this.i !== -1 ? 'Update' : 'Add';
    const message = this.i !== -1
      ? 'Are you sure you want Change Field ?' : 'Are you sure you want Add Field ?';
    Util.confirmAlert(title, message, title, 'No',
      () => {
        this.setState({ ...this.state, inApiCall: true });
        ModulAPI.saveField(this.state.field, this.onSuccess, this.onFail);
      });
  };
  onSuccess = () => {
    Util.showNotification('Successful', 'Field changed successfully.', 'success');
    this.setState({ ...this.state, inApiCall: false });
    this.props.onModuleChanged();
    this.fields = this.loadModelList();
  };

  delete = i => {
    Util.confirmAlert('Delete', `Are you sure you want to delete ${this.fields[i].label_name}`,
      'Delete', 'No', () => {
        this.setState({ ...this.state, inApiCall: true });
        ModulAPI.deleteField(this.fields[i].id, this.onDeleteSuccess, this.onFail);
      });
  };
  onDeleteSuccess = () => {
    Util.showNotification('Successful', 'Delete successfully.', 'success');
    this.props.onModuleChanged();
    this.fields = this.loadModelList();
  };

  getEditableFields = () => {
    return this.fields
      .filter((field) => field.editable === 1)
      .map((field) => ({
        value: field.field_key,
        label: field.label_name,
      }));
  };

  onCombineChange = (evt) => {
    const field = { ...this.state.field };
    const val = evt.map(item => item.value);
    field.combine = val.length > 1 ? val.join(',') : val.join('');
    this.setState({ ...this.state, field: field });
  };

  render() {
    if (!this.List) return null;
    const canAdd = this.modelNo === Const.Lead || this.modelNo === Const.Contact
      || this.modelNo === Const.Call || this.modelNo === Const.Meeting
      || this.modelNo === Const.SalesOrder || this.modelNo === Const.Installment
      || this.modelNo === Const.Property || this.modelNo === Const.Project
      || this.modelNo === Const.UserNo;
    const isSpecial = !this.fields[this.i]
      || (this.fields[this.i] && this.fields[this.i].status !== Const.SpecialField);

    const combine = [];
    if (this.state.field && this.state.field.combine) {
      const tmp = this.state.field.combine.split(',');
      for (let i = 0; i < tmp.length; i++) {
        const option = this.options.find(option => option.value === tmp[i]);
        if (option) {
          combine.push(option);
        }
      }
    }

    return (
      <>
        <Modal show={this.state.popup} onHide={this.hide}
          size="md" aria-labelledby="contained-modal-title-vcenter" centered className="fieldpop">

          <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title-vcenter">Add Field</Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <Form className="fieldmodulef">
              <Row className="row-cols-2 colmr">
                <Col xs={12}>
                  <Form.Label>Field Name</Form.Label>
                  <Form.Control type="text" placeholder="Name" className="mr-sm-2"
                    value={this.state.field.label_name}
                    onChange={event => this.onChange('label_name', event.target.value)} />
                </Col>
              </Row>

              <Row className="row-cols-2 colmr">
                <Col xs={6}>
                  <Form.Check checked={this.state.field.visible === Const.True}
                    onChange={evt => this.onCheckChange('visible', evt.target.checked)} />
                  <Form.Label>Visible</Form.Label>
                </Col>
                {isSpecial ?
                  <Col xs={6}>
                    <Form.Check checked={this.state.field.editable === Const.True}
                      onChange={evt => this.onCheckChange('editable', evt.target.checked)} />
                    <Form.Label>Editable</Form.Label>
                  </Col>
                  : null
                }
              </Row>

              <Row className="row-cols-2 colmr">
                {!this.fields[this.i] ?
                  <Col xs={6}>
                    <Form.Label>Field Type</Form.Label>
                    <Select className="mr-sm-2" value={this.state.field.type}
                      onChange={this.onFieldTypeChange} options={this.fieldOptions} />
                  </Col>
                  : null
                }

                {isSpecial ?
                  <Col xs={6}>
                    <Form.Label>Field Order</Form.Label>
                    <Form.Control type="text" placeholder="Field Order" className="mr-sm-2"
                      value={this.state.field.field_order}
                      onChange={evt => this.onChange('field_order', evt.target.value)} />
                  </Col>
                  : null
                }
              </Row>

              {isSpecial ?
                <Row className="row-cols-2 colmr">
                  <Col xs={12}>
                    <Form.Label>Validate</Form.Label>
                    <Form.Control type="text" placeholder="Validate" className="mr-sm-2"
                      value={this.state.field.validate}
                      onChange={evt => this.onChange('validate', evt.target.value)} />
                  </Col>
                </Row>
                : null
              }

              <Row className="row-cols-2 colmr">
                {isSpecial ?
                  <Col xs={6}>
                    <Form.Check
                      onChange={evt => this.onCheckChange('non_duplicate', evt.target.checked)}
                      checked={this.state.field.non_duplicate === Const.True} />
                    <Form.Label>Unique</Form.Label>
                  </Col>
                  : null
                }

                {isSpecial ?
                  <Col xs={6}>
                    <Form.Check
                      onChange={evt => this.onCheckChange('form_mandate', evt.target.checked)}
                      checked={this.state.field.form_mandate === Const.True} />
                    <Form.Label>Form Mandatory/ Compulsory</Form.Label>
                  </Col>
                  : null
                }
              </Row>

              <Row className="row-cols-2 colmr">
                {isSpecial ?
                  <Col xs={6}>
                    <Form.Check
                      onChange={evt => this.onCheckChange('api_mandate', evt.target.checked)}
                      checked={this.state.field.api_mandate === Const.True} />
                    <Form.Label>API Mandatory/ Compulsory</Form.Label>
                  </Col>
                  : null
                }

                {isSpecial ?
                  <Col xs={6}>
                    <Form.Check checked={this.state.field.import_mandate === Const.True}
                      onChange={event =>
                        this.onCheckChange('import_mandate', event.target.checked)} />
                    <Form.Label>Import Mandatory/ Compulsory</Form.Label>
                  </Col>
                  : null
                }
              </Row>

              {isSpecial ?
                <Row className="row-cols-2 colmr">
                  <Col xs={6}>
                    <Form.Check checked={this.state.field.filter_visible === Const.True}
                      onChange={evt => this.onCheckChange('filter_visible', evt.target.checked)} />
                    <Form.Label>Filter Visible</Form.Label>
                  </Col>
                  <Col xs={6}>
                    <Form.Label>Filter Field Order</Form.Label>
                    <Form.Control type="text" placeholder="Search" className="mr-sm-2"
                      value={this.state.field.filter_field_order}
                      onChange={evt => this.onChange('filter_field_order', evt.target.value)} />
                  </Col>
                </Row>
                : null
              }

              {isSpecial ?
                <Row className="row-cols-2 colmr">
                  <Col xs={12}>
                    <Form.Label>Default Value</Form.Label>
                    <Form.Control type="text" placeholder="Type" className="mr-sm-2"
                      value={this.state.field.default_value}
                      onChange={evt => this.onChange('default_value', evt.target.value)} />
                  </Col>
                </Row>
                : null
              }

              {isSpecial ?
                <Row className="row-cols-2 colmr">
                  <Col xs={12}>
                    <Form.Label>Calculate</Form.Label>
                    <Form.Control type="text" placeholder="Type" className="mr-sm-2"
                      value={this.state.field.calculate}
                      onChange={evt => this.onChange('calculate', evt.target.value)} />
                  </Col>
                </Row>
                : null
              }
              {isSpecial ?
                <Row className="row-cols-2 colmr">
                  <Col xs={12}>
                    <Form.Label>Combine Field</Form.Label>
                    <Select
                      className="mr-sm-2"
                      name="combine"
                      value={combine}
                      onChange={evt => this.onCombineChange(evt)}
                      options={this.options}
                      isMulti={true}
                    />
                  </Col>
                </Row>
                : null
              }
            </Form>
          </Modal.Body>

          <Modal.Footer> <Button onClick={this.submit}>Submit</Button> </Modal.Footer>
        </Modal>

        <div className="sectionlist pt-3">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-8 ">
                <h3>{this.model.model_name} Field List</h3>
              </div>
              {canAdd && this.Add ?
                <div className="col-md-4 text-right">
                  <span className="buttons success" onClick={() => this.show(-1)} >
                    + Add Custom Field
                  </span>
                </div>
                : null
              }
            </div>

            <div className="row">
              <div className="col-md-12 tablefield">
                <Table striped bordered hover responsive>
                  <FieldListHeader context={DefaultControllerConst.Global} view={true} />
                  <ApiUiController inApiCall={this.props.inApiCall}>
                    <FieldListRows view={true} fields={this.fields} show={this.show}
                      Update={this.Update} Delete={this.Delete} CatList={this.CatList}
                      delete={this.delete} path={this.path} context={this.props.context}
                      showConditional={this.showConditional} />
                  </ApiUiController>
                </Table>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}
export default withRouter(FieldList);